import $ from 'jquery';
import pv from './vendor/parallax-vanilla';

$(function () {
  pv.init({
    container: {
      class: 'parallax',
      height: '275px'
    },
    block: {
      class: 'parallax__block',
      speed: -Math.PI
    }
  });
});
